import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { catchError, throwError, switchMap } from "rxjs";

import { Router } from '@angular/router';
import { AccountService } from '../_services/account/account.service';
import { SessionService } from '../_services/session/session.service';


export const networkErrorInterceptor: HttpInterceptorFn = (req, next) => {
  
  const endpoint: string = "party";
  const toastr = inject(ToastrService);
  const accountService = inject(AccountService);
  const sessionService = inject(SessionService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const isJwtExpired = error.error?.message === 'jwt expired' || 
                           error.error?.msg === 'jwt expired' || 
                           error.error?.Error === 'jwt expired' ||
                           (error.error?.errors && JSON.stringify(error.error.errors).toLowerCase().includes('jwt expired')) ||
                           (error.message && error.message.toLowerCase().includes('jwt expired'));

      if (isJwtExpired && !req.url.includes(`${endpoint}/auth/refresh`) && !req.url.includes(`${endpoint}/auth/login`)) {
        const currentUser = sessionService.getCurrentUser();
        const refreshToken = (currentUser as any)?.refreshToken;

        if (refreshToken) {
          return accountService.refreshToken(refreshToken).pipe(
            switchMap((res: any) => {
              if (res?.auth?.token) {
                const updatedUser = { ...currentUser, refreshToken: res.data?.refreshToken || refreshToken };
                sessionService.setSession(res.auth.token, updatedUser as any, true);
                
                const clonedReq = req.clone({
                  setHeaders: {
                    Authorization: `Bearer ${res.auth.token}`
                  }
                });
                return next(clonedReq);
              } else {
                accountService.logout();
                sessionService.clearSession();
                router.navigate(['/login']);
                return throwError(() => error);
              }
            }),
            catchError((refreshErr) => {
              accountService.logout();
              sessionService.clearSession();
              router.navigate(['/login']);
              return throwError(() => refreshErr);
            })
          );
        } else {
          accountService.logout();
          sessionService.clearSession();
          router.navigate(['/login']);
          return throwError(() => error);
        }
      }

      let errorMessage = 'An unexpected error occurred';

      if (error.status === 0) {
        // A client-side or network error occurred.
        errorMessage = '(Network) Please check your internet connection or contact support.';
      } else {
        // Show the real message from the API.
        errorMessage = error.error?.msg || error.error?.message || error.message || errorMessage;
      }

      console.error('API Error:', error);
      toastr.error(errorMessage);
      
      const apiError = {
        ApiError: error.error,
        message: errorMessage,
        status: error.status,
        originalError: error
      };

      return throwError(() => apiError);
    })
  );
};

